<template>
  <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
    <p class="text-sm text-gray-500">Exibindo {{ startItem }}-{{ endItem }} de {{ totalItems }} {{ itemLabel }}</p>

    <div class="flex items-center justify-center gap-2">
      <button
        type="button"
        class="h-10 rounded-xl border border-gray-200 bg-white px-4 text-sm font-medium text-gray-700 shadow-sm transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
        :disabled="currentPage <= 1"
        @click="goTo(currentPage - 1)"
      >
        Anterior
      </button>

      <template v-for="(page, index) in pages">
        <span v-if="page.type === 'ellipsis'" :key="`${page.type}-${index}`" class="flex h-10 min-w-10 items-center justify-center rounded-xl border border-transparent px-2 text-sm font-medium text-gray-400"> ... </span>

        <button
          v-else
          :key="page.value"
          type="button"
          class="h-10 min-w-10 rounded-xl border px-4 text-sm font-medium shadow-sm transition"
          :class="page.value === currentPage ? 'border-blue-500 bg-blue-500 text-white' : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50'"
          @click="goTo(page.value)"
        >
          {{ page.value }}
        </button>
      </template>

      <button
        type="button"
        class="h-10 rounded-xl border border-gray-200 bg-white px-4 text-sm font-medium text-gray-700 shadow-sm transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
        :disabled="currentPage >= totalPages"
        @click="goTo(currentPage + 1)"
      >
        Próxima
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppPagination",
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    },
    totalItems: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    itemLabel: {
      type: String,
      default: "itens"
    }
  },
  computed: {
    pages() {
      const total = Math.max(1, this.totalPages);
      const current = Math.min(Math.max(this.currentPage, 1), total);

      if (total <= 7) {
        return Array.from({ length: total }, (_, index) => ({
          type: "page",
          value: index + 1
        }));
      }

      const pages = [{ type: "page", value: 1 }];
      const windowStart = Math.max(2, current - 1);
      const windowEnd = Math.min(total - 1, current + 1);

      if (windowStart > 2) {
        pages.push({ type: "ellipsis" });
      }

      for (let page = windowStart; page <= windowEnd; page += 1) {
        pages.push({ type: "page", value: page });
      }

      if (windowEnd < total - 1) {
        pages.push({ type: "ellipsis" });
      }

      pages.push({ type: "page", value: total });

      return pages;
    },
    startItem() {
      if (this.totalItems === 0) {
        return 0;
      }

      return (this.currentPage - 1) * this.pageSize + 1;
    },
    endItem() {
      return Math.min(this.currentPage * this.pageSize, this.totalItems);
    }
  },
  methods: {
    goTo(page) {
      const nextPage = Math.min(Math.max(page, 1), Math.max(1, this.totalPages));
      this.$emit("paginate", nextPage);
      this.$emit("update:currentPage", nextPage);
    }
  }
};
</script>
